<template>
<div class="mainWrap">
  <div class="mainHeader">
    <div class="mainLogoWrap">
      <div class="mainLogo"></div>
    </div>
    <div class="mainAddress">
      <div class="flex">
        <p @click='createPopUp("#app.cusLayer")'>{{this.mainAddress}}</p>
        <div class="addressArrow" @click='createPopUp("#app.cusLayer")'></div>
      </div>

      <div class='btnNavi langNavi' v-if="this.isGlobalButtonEnabled()">
        <span
          @click="toggleLangBox"
          class="ico lang"
          :class="{ ko: isKo, en: isEn, cn: isCn}"></span>
        <div class="langBox" style="display: none">
          <span class="ico lang ko" @click="setKorean()"></span>
          <span class="ico lang en" @click="setEnglish()"></span>
          <span class="ico lang ch" @click="setChinese()"></span>
        </div>
      </div>
      <div class="mainNoti" @click="moveNotify()"></div>
    </div>
  </div>
  <div class="mainContainer">
    <div class="mainBg">
      <div class="mainContent">
        <div class="mainSearch">
          <input type='text'
            :placeholder="$i18n.locale == 'ko' ? '매장명 검색' : $i18n.locale == 'en' ? 'Store name search' : '店铺名称搜索'"
            @click='searchBtn'/>
          <div class="mainSearchIco" @click='searchBtn'></div>
        </div>
        <div class="mainCateWrap" v-show="list.length > 0">
          <div v-for="(item,index) in list" :key="index" class="mainCate" @click="moveList(item)">
            <div>
            </div>
            <template>
              <img class="mainCateImg" :src="setImg(item.detailCode)" alt="image">
              <span>{{$i18n.locale == 'ko' ? item.langKrNm : $i18n.locale == 'en' ? item.langEnNm : $i18n.locale == 'cn' ? item.langChNm : item.langKrNm}}</span>
            </template>
          </div>
        </div>
        <div class="draditional" @click="moveList(item)">
          <div class="draditionalLeft">
            <div class="draditionalTit">
              <p>전통관</p>
              <div class="arrow"></div>
            </div>
            <div class="draditionalTxt">온누리상품권, 전통시장</div>
          </div>
          <div class="draditionalRight">
            <img src="../assets/img/img-draditional-market.png" style="width: 100%; height:80px;">
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-banner" v-if="$i18n.locale == 'cn'">
      <img src="../assets/img/banner-main-web-01-chi.png" style="width: 100%;">
    </div>
    <div class="bottom-banner" v-else-if="$i18n.locale == 'en'">
      <img src="../assets/img/banner-main-web-01-en.png" style="width: 100%;">
    </div>
    <div class="bottom-banner" v-else>
      <img src="../assets/img/banner-main-web-01-kor.png" style="width: 100%;">
    </div>
    <AppCompanyInfo class="pb65"/>
  </div>
  <AppMainAddress
    :addressList.sync="addressList"
    :homeFlag="homeFlag"
    @addresslist="addresslist"
    @moveGroup="moveGroup"
    @closePopUp="handleClosePopUp"
  />
  <BottomMenu />
  <SingleBtnDialog
    v-if='showSingleBtnDialogFlag'
    :messageType='singleBtnMsgType'
    :onClickConfirmBtn='onClickConfirmBtn'/>
  <NoticePopup v-if="currentPopup"
    :noticeList="currentPopup"
    :popupIndex="currentPopupIndex"
    :popupTomorrowFlag="popupTomorrowFlags[currentPopupIndex] || false"
    @updatePopupFlag="updatePopupFlag"
    @closePopup="closePopup"
  >
  </NoticePopup>
</div>
</template>
<script>
/* eslint-disable eqeqeq */
import $ from 'jquery'
import service from '@/backend/modnpay_app_api'
import NoticePopup from '@/components/App/NoticePopup.vue'
import BottomMenu from '@/components/App/BottomMenu.vue'
import AppCompanyInfo from '@/components/App/AppCompanyInfo.vue'
import AppMainAddress from '@/components/App/AppMainAddress.vue'
import SingleBtnDialog from '@/components/Dialog/SingleBtnDialog.vue'
export default {
  name: 'TestMain',
  components: {
    BottomMenu, AppMainAddress, SingleBtnDialog, AppCompanyInfo, NoticePopup
  },
  data () {
    return {
      noticeList: [], // API에서 받아온 공지 목록
      currentPopupIndex: 0, // 현재 표시 중인 팝업의 인덱스
      popupTomorrowFlags: [], // 각 팝업별 '오늘 하루 보지 않기' 체크 상태

      homeFlag: false,
      mainAddress: '',
      list: [], // 그룹QR 카테고리 응답리스트
      addressList: [],
      addressByLotNum: '', // 지번주소
      showSingleBtnDialogFlag: false,
      singleBtnMsgType: ''
    }
  },
  computed: {
    isKo () {
      return this.$i18n.locale === 'ko'
    },
    isEn () {
      return this.$i18n.locale === 'en'
    },
    isCn () {
      return this.$i18n.locale === 'cn'
    },
    currentPopup () {
      return this.noticeList[this.currentPopupIndex] || null
    }
  },
  beforeCreate () {
    localStorage.removeItem('recentAddress')
  },
  watch: {
    noticeList: {
      handler (newList) {
        this.popupTomorrowFlags = new Array(newList.length).fill(false) // 공지 개수만큼 초기화
      },
      immediate: true // 값이 처음 설정될 때도 handler가 호출됨
    }
  },
  created () {
    localStorage.setItem('appFlag', true)
    localStorage.setItem('appUserCode', 'A-095ccb0ea2f14df193f67d115489c626')
    localStorage.setItem('deviceId', '91d21454ba3bbf23')
  },
  mounted () {
    this.noticePopupList()
    this.addresslist()
    this.callCategoryList()
  },
  updated () {
    sessionStorage.getItem('langType')
      ? this.$i18n.locale = sessionStorage.getItem('langType')
      : this.$i18n.locale = this.$store.getters.langType
  },
  methods: {
    async noticePopupList () {
      const req = {
        displayType: '13' // 관리자에서 관리하는 온누리오더 앱 구분 값
      }
      const { data } = await service.noticePopupList(req)
      if (data.resultCode === 0) {
        // 쿠키에서 'popup_'으로 저장된 공지 seq 값 추출
        const cookies = document.cookie.split('; ').map(cookie => cookie.split('=')[0])
        const popupSeqs = cookies
          .filter(cookie => cookie.startsWith('popup_'))
          .map(cookie => Number(cookie.replace('popup_', '')))

        // 쿠키에 없는 공지만 리스트에 저장
        this.noticeList = data.noticeList.filter(notice => !popupSeqs.includes(notice.noticeSeq))

        if (this.noticeList.length > 0) {
          document.querySelector('body').style.overflow = 'hidden'
        }
        // 첫 번째 팝업부터 표시
        this.currentPopupIndex = 0
      }
    },
    closePopup () {
      const currentNotice = this.noticeList[this.currentPopupIndex]

      // '오늘 하루 보지 않기' 체크 여부 확인
      if (this.popupTomorrowFlags[this.currentPopupIndex]) {
        const expireDate = new Date()
        expireDate.setHours(23, 59, 59, 999) // 오늘 밤 12시까지 유효
        document.cookie = `popup_${currentNotice.noticeSeq}=true; expires=${expireDate.toUTCString()}; path=/`
        this.saveCookie(`popup_${currentNotice.noticeSeq}=true; expires=${expireDate.toUTCString()};`)
      }

      // 다음 팝업으로 이동
      if (this.currentPopupIndex < this.noticeList.length - 1) {
        this.currentPopupIndex++
      } else {
        document.querySelector('body').removeAttribute('style')
        this.currentPopupIndex = -1 // 모든 팝업이 닫히면 숨김
      }
    },
    updatePopupFlag (index, value) {
      this.$set(this.popupTomorrowFlags, index, value) // Vue의 반응성을 유지하며 배열 값 업데이트
    },

    toggleLangBox () {
      $('.langNavi .langBox').fadeToggle(200)
    },
    setKorean () {
      this.$i18n.locale = 'ko'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = '모든오더'
      this.toggleLangBox()
    },
    setEnglish () {
      this.$i18n.locale = 'en'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = '모든오더'
      this.toggleLangBox()
    },
    setChinese () {
      this.$i18n.locale = 'cn'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = 'MODNPAY智慧点餐'
      this.toggleLangBox()
    },
    async callCategoryList () { // 카테고리 및 주소 조회
      const req = {}
      const { data } = await service.foodClassList(req)

      if (data.resultCode == '0' || data.resultCode == '0000000') { // 성공
        this.list = data.list
        this.addressByLotNum = data.addressByLotNum
        this.mainAddress = data.mainAddress
      }
    },
    moveList (item) {
      sessionStorage.setItem('categoryCode', item.detailCode)
      sessionStorage.setItem('addressByLotNum', this.addressByLotNum)
      this.$router.push({ name: 'AppStoreList' })
    },
    async addresslist () { // 주소 목록 조회 메서드
      const req = {}
      const { data } = await service.addresslist(req)
      if (data.resultCode == '0') { // 성공 시
        this.addressList = data.addressList // 주소 리스트 설정
        this.homeFlag = data.addressList.map(item => item.addressType).includes(0) // 집 주소 플래그 설정
        const mainAddress = data.addressList.filter(item => item.mainFlag == '1')
        sessionStorage.setItem('selectAddress', JSON.stringify(mainAddress[0]))
        this.loading = false
      }
    },
    setImg (code) {
      switch (code) {
        case '010100': return require('../assets/img/ic_food_korea.png')
        case '020100': return require('../assets/img/ic_food_chicken.png')
        case '030100': return require('../assets/img/ic_food_ricecake.png')
        case '040100': return require('../assets/img/ic_food_china.png')
        case '050100': return require('../assets/img/ic_food_japan.png')
        case '060100': return require('../assets/img/ic_food_bowl.png')
        case '070100': return require('../assets/img/ic_food_pizza.png')
        case '080100': return require('../assets/img/ic_food_buger.png')
        case '090100': return require('../assets/img/ic_food_western.png')
        case '100100': return require('../assets/img/ic_food_pig.png')
        case '110100': return require('../assets/img/ic_food_cake.png')
        case '120100': return require('../assets/img/ic_food_salad.png')
        case '130100': return require('../assets/img/ic_food_night.png') // 야식
        case '140100': return require('../assets/img/ic_food_asian.png') // 아시안
        case '150100': return require('../assets/img/ic_food_meat.png') // 고기구이
        case '160100': return require('../assets/img/ic_food_franchise.png') // 프랜차이즈
      }
    },
    handleClosePopUp () { // 팝업 닫기 이벤트 핸들러
      this.callCategoryList()
      this.addresslist()
    },
    onClickConfirmBtn () {
      this.showSingleBtnDialogFlag = false
    },
    moveGroup () {
      this.removePopUp()
      this.$router.push({
        name: 'AppMain',
        query: {
          addressByLotNum: this.addressByLotNum
        }
      })
    },
    searchBtn () {
      // 검색어 조건 검사
      this.$router.push({
        name: 'SEARCH',
        query: {
          searchType: 1
        }
      })
    },
    moveNotify () {
      this.$router.push({ name: 'AppNotify' })
    }
  }
}
</script>
<style scoped>
.pb65{padding-bottom: 65px !important;}
.button-group__first-line-image{flex-wrap: wrap;}
#footer{ background-color: #fff; padding-bottom: 0; margin-bottom: 53px}
</style>
